export class Pagination extends React.Component {

    changePage(newPage, ev) {
        ev.preventDefault();

        var data = this.props.data;
        data["pageNumber"] = newPage;
        this.props.onChange(data);
    }

    render() {
        var requiredPages = [];
        if (this.props.data.pageCount <= 10) {
            for (var i = 1; i <= this.props.data.pageCount; i++) {
                requiredPages.push(i);
            }
        }
        else
        {
            if (this.props.data.pageNumber < 5)
            {
                requiredPages.push(1);
                requiredPages.push(2);
                requiredPages.push(3);
                requiredPages.push(4);
                requiredPages.push(5);
                requiredPages.push(6);
                requiredPages.push(7);
                requiredPages.push('...');
                requiredPages.push(this.props.data.pageCount - 1);
                requiredPages.push(this.props.data.pageCount);
            }
            else if (this.props.data.pageNumber > this.props.data.pageCount - 5)
            {
                requiredPages.push(1);
                requiredPages.push(2);
                requiredPages.push('...');
                requiredPages.push(this.props.data.pageCount - 6);
                requiredPages.push(this.props.data.pageCount - 5);
                requiredPages.push(this.props.data.pageCount - 4);
                requiredPages.push(this.props.data.pageCount - 3);
                requiredPages.push(this.props.data.pageCount - 2);
                requiredPages.push(this.props.data.pageCount - 1);
                requiredPages.push(this.props.data.pageCount);
            }
            else
            {
                requiredPages.push(1);
                requiredPages.push(2);
                requiredPages.push('...');
                requiredPages.push(this.props.data.pageNumber - 2);
                requiredPages.push(this.props.data.pageNumber - 1);
                requiredPages.push(this.props.data.pageNumber);
                requiredPages.push(this.props.data.pageNumber + 1);
                requiredPages.push(this.props.data.pageNumber + 2);
                requiredPages.push('...');
                requiredPages.push(this.props.data.pageCount - 1);
                requiredPages.push(this.props.data.pageCount);
            }
        }

        var listData = [];

        for (var i = 0; i < requiredPages.length; i++) {
            var page = requiredPages[i];
            var className = "page-item";
            if (page == this.props.data.pageNumber) {
                className += " active";
            }

            if (page == '...')
            {
                listData.push(<li key={"..." + i} className={className}><span className="page-skip">{page}</span></li>);
            }
            else
            {
                listData.push(<li key={page} className={className}><a className="page-link" href="#" onClick={this.changePage.bind(this, page)}>{page}</a></li>);
            }

        }

        if (this.props.data.pageCount == 1) {
            return null;
        }

            return (<nav className="pagination justify-content-center">
            <ul className="pagination">
                <li className={"page-item" + (this.props.data.isFirstPage ? " disabled" : "")}>
                    <a className="page-link" href="#" tabIndex="-1" onClick={this.changePage.bind(this, this.props.data.pageNumber - 1)}>Previous</a>
                </li>
                {listData}
                <li className={"page-item" + (this.props.data.isLastPage ? " disabled" : "")}>
                    <a className="page-link" href="#" onClick={this.changePage.bind(this, this.props.data.pageNumber + 1)}>Next</a>
                </li>
            </ul>
        </nav>)
    }
}